import React from 'react';
import { API } from 'aws-amplify';
import { toast } from 'react-toastify';

import { basicReducer as reducer } from '../../../../utils/reducers';

import useStyles from './styles';

const initState = {
    isDoingAjax: false,
    confirmation: false,
};

const useDeleteApplication = () => {
    const [state, dispatch] = React.useReducer(reducer, initState);
    const styles = useStyles();

    const deleteApp = async (appInstId, callback) => {
        dispatch({
            type: 'doingAjax',
        });
        var toastId = toast.loading('Deleting application...');

        try {
            await API.post('ShipyardAPI', '/admin/delete_application', {
                body: {
                    appInstId,
                },
            });

            toast.success('Application deleted successfully.');

            callback?.();
        } catch (e) {
            console.error('Error occurred:', e);
            toast.error(e?.response?.data?.message || 'API error.');
        } finally {
            toast.dismiss(toastId);
            dispatch({
                type: 'ajaxDone',
            });
        }
    };

    const handleCheckbox = (checked) => {
        dispatch({
            type: 'update',
            newState: {
                confirmation: checked,
            },
        });
    };

    const reset = () =>
        dispatch({
            type: 'update',
            newState: initState,
        });

    return {
        ...state,
        ...styles,
        handleCheckbox,
        reset,
        deleteApp,
    };
};

export default useDeleteApplication;
